<template>
  <div class="container" style="padding: 6rem 0px;">
    <div class="card">
      <div class="row">
        <div class="col-sm-5 border-right">
          <aside>
            <article class="gallery-wrap">
              <div class="img-big-wrap">
                <div style="padding: 2rem" ref="imageContainer">
                  <a href="#"
                    ><img :src="currentImage" style="width: 100%; height: 100%"
                  /></a>
                </div>
              </div>
              <div class="img-small-wrap">
                <div
                  v-for="(image, i) in product.images"
                  :key="i"
                  class="item-gallery"
                  @click="changeImage(i)"
                >
                  <img :src="image" />
                </div>
              </div>
            </article>
          </aside>
        </div>
        <div class="col-sm-7">
          <aside>
            <article class="card-body p-5">
              <h3 class="title mb-3">{{ product.title }}</h3>
              <p class="price-detail-wrap">
                <span class="price h3 text-warning">
                  <span class="currency"></span
                  ><span class="num">{{ product.price | priceFormatter }}</span>
                </span>
              </p>
              <dl class="item-property">
                <dt>Description</dt>
                <dd>
                  <p class="text-capitalize">{{ product.description }}</p>
                </dd>
              </dl>
              <dl class="param param-feature">
                <dt>Brand</dt>
                <dd class="text-capitalize">{{ product.brand }}</dd>
              </dl>
              <dl class="param param-feature">
                <dt>Size</dt>
                <dd>{{ product.size }}</dd>
              </dl>
              <dl class="param param-feature">
                <dt>Camera</dt>
                <dd>{{ product.camera }}</dd>
              </dl>
              <dl class="param param-feature">
                <dt>CPU</dt>
                <dd>{{ product.cpu }}</dd>
              </dl>
              <dl class="param param-feature">
                <dt>Memory</dt>
                <dd>{{ product.memory }}</dd>
              </dl>
              <dl class="param param-feature">
                <dt>Display</dt>
                <dd>{{ product.display }}</dd>
              </dl>
              <dl class="param param-feature">
                <dt>Battery</dt>
                <dd>{{ product.battery }}</dd>
              </dl>
              <hr />
              <button
                @click="addProductToCart(product)"
                class="btn btn-lg btn-outline-primary text-uppercase"
              >
                <i class="fa fa-shopping-cart"></i> Add to cart
              </button>
            </article>
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ProductDetail",
  data() {
    return {
      product: this.$store.state.products.find(
        p => p.id === +this.$route.params.id
      ),
      id: 0,
      currentImage: this.$store.state.products.find(
        p => p.id === +this.$route.params.id
      ).images[0]
    };
  },
  methods: {
    ...mapActions(["addProductToCart"]),
    changeImage(n) {
      this.currentImage = this.product.images[n];
    }
  }
};
</script>

<style scoped>
.gallery-wrap .img-big-wrap img {
  height: 450px;
  width: auto;
  display: inline-block;
}
.gallery-wrap .img-small-wrap .item-gallery {
  width: 60px;
  height: 60px;
  border: 1px solid #ddd;
  margin: 7px 2px;
  display: inline-block;
  overflow: hidden;
}
.gallery-wrap .img-small-wrap {
  text-align: center;
}
.gallery-wrap .img-small-wrap img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}
</style>
